export const WORKOUT_TYPES = {
  ROUTE: 'route',
  TRAINING: 'training',
};
